module.exports = __webpack_public_path__ + "img/FI10883214.68dacb20.png";